import { createAction, props } from '@ngrx/store';
import { Pagination } from '@app/shared/models/pagination';
import { Candidate } from 'src/app/shared/models/candidate';
import { HttpErrorResponse } from '@angular/common/http';
import { AiSummaryResponse } from '@app/shared/models/agent-chat.models';

export const loadCandidates = createAction(
  '[Candidates] Load Candidates',
  props<{ payload: { page: number } }>(),
);

export const loadCandidatesSuccess = createAction(
  '[Candidates] Load Candidates Success',
  props<{ payload: { candidatesPage: Pagination<Candidate> } }>(),
);

export const loadCandidatesError = createAction(
  '[Candidates] Load Candidates Error',
  props<{ error: HttpErrorResponse }>(),
);

export const deleteCandidate = createAction(
  '[Candidates] Delete Candidate',
  props<{ payload: { candidateId: string } }>(),
);

export const loadAiSummaries = createAction(
  '[Candidates] Load AI Summaries',
  props<{ payload: { candidateId: string; resume: string; matchingScore: number } }>(),
);

export const loadAiSummariesSuccess = createAction(
  '[Candidates] Load AI Summaries Success',
  props<{ payload: { summary: AiSummaryResponse } }>(),
);

export const loadAiSummariesError = createAction(
  '[Candidates] Load AI Summaries Error',
  props<{ error: HttpErrorResponse }>(),
);

export const resetCandidatesState = createAction('[Candidates] Reset Candidates State');

export const setStatusId = createAction(
  '[Candidates] Set Status ID',
  props<{ payload: { statusId: number | null } }>(),
);
